export const colors = {
  primary: "#021626",
  secondary: "#01e9eb",
  dark: "#08aced",
  light: "#08f1f3",
  gray: "#c4c4c4",
  success: "#66ab57",
  info: "#9ab6da",
  warning: "#e49b1f",
  danger: "#f44336",
  warning: "#fbd46d",
  danger: "#ec0101",
  go: "#158467",
};
